import { useState } from 'react';
import { Bot, X } from 'lucide-react';

const EnhancedChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {isOpen ? (
        <div className="w-96 md:w-[450px] h-[500px] bg-white shadow-xl rounded-lg flex flex-col border border-gray-200">
          {/* Chat header */}
          <div className="p-4 bg-blue-600 text-white rounded-t-lg flex justify-between items-center">
            <span className="font-medium flex items-center">
              <Bot size={20} className="mr-2" />
              Antz Assistant
            </span>
            <button
              onClick={toggleChat}
              className="p-1 text-white hover:text-gray-200 transition-colors"
              title="Close Chat"
            >
              <X size={18} />
            </button>
          </div>

          {/* Coming Soon Content */}
          <div className="flex-1 flex items-center justify-center p-8 bg-gray-50">
            <div className="text-center">
              <div className="mx-auto w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mb-4">
                <Bot className="h-8 w-8 text-blue-600" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                Coming Soon
              </h2>
              <p className="text-gray-500 text-sm">
                AI-powered chat assistant with document search and intelligent responses will be available soon.
              </p>
              <div className="flex justify-center gap-1 mt-4">
                <span className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
                <span className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
                <span className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <button
          onClick={toggleChat}
          className="w-12 h-12 bg-blue-600 text-white rounded-full shadow-lg flex items-center justify-center hover:bg-blue-700 transition-colors"
        >
          <Bot size={24} />
        </button>
      )}
    </div>
  );
};

export default EnhancedChatbot;
